import { render, staticRenderFns } from "./telegramButton.vue?vue&type=template&id=48bca1ca&"
import script from "./telegramButton.vue?vue&type=script&lang=js&"
export * from "./telegramButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports